import React from 'react';
import type { GameType } from '@sparted/shared-library/business/types';
import type { LanguageCode } from '@sparted/shared-library/business/types';

import UImage from 'Components/unit/UImage/UImage';
import { AVAILABLE_BO_LANGUAGES } from 'Services/language/languageService';

import styles from './SGameplayPreviewImage.style';

const gameplayImages: Record<'en-US' | 'fr-FR', Record<GameType, string>> = {
  'fr-FR': {
    mcq: 'assets/img/gameplays/fr-FR/mcq.png',
    'error-text': 'assets/img/gameplays/fr-FR/error-text.png',
    'open-question': 'assets/img/gameplays/fr-FR/open-question.png',
    'no-interaction': 'assets/img/gameplays/fr-FR/no-interaction.png',
    'picture-spot': 'assets/img/gameplays/fr-FR/picture-spot.png',
    'swiping-cards': 'assets/img/gameplays/fr-FR/swiping-cards.png',
    'ordering-cards': 'assets/img/gameplays/fr-FR/ordering-cards.png',
  },
  'en-US': {
    mcq: 'assets/img/gameplays/en-US/mcq.png',
    'error-text': 'assets/img/gameplays/en-US/error-text.png',
    'open-question': 'assets/img/gameplays/en-US/open-question.png',
    'no-interaction': 'assets/img/gameplays/en-US/no-interaction.png',
    'picture-spot': 'assets/img/gameplays/en-US/picture-spot.png',
    'swiping-cards': 'assets/img/gameplays/en-US/swiping-cards.png',
    'ordering-cards': 'assets/img/gameplays/en-US/ordering-cards.png',
  },
};

type SGameplayPreviewImageProps = {
  language: LanguageCode;
  gameplayType: GameType;
};

export const SGameplayPreviewImage = ({ language, gameplayType }: SGameplayPreviewImageProps) => {
  if (!AVAILABLE_BO_LANGUAGES.includes(language)) {
    return null;
  }

  return (
    <div style={styles.container}>
      <UImage src={gameplayImages[language as 'fr-FR' | 'en-US'][gameplayType]} height={300} width={146} />
    </div>
  );
};
